import { render, staticRenderFns } from "./userOfCourse.vue?vue&type=template&id=562fc19c&"
import script from "./userOfCourse.vue?vue&type=script&lang=js&"
export * from "./userOfCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports